// src/tracking.ts
var TRACKING_CONFIG = {
  /** How often the widget reports liveness and time-on-page. */
  heartbeatIntervalMs: 5e3,
  /** How long a queued batch waits before being flushed. */
  batchFlushIntervalMs: 2e3,
  /** Queue size that triggers an immediate flush. */
  batchMaxSize: 20,
  /** Idle gap after which a returning visitor starts a new session. */
  sessionIdleTimeoutMs: 30 * 60 * 1e3,
  /** Presence key TTL. Must exceed the heartbeat interval with room to spare. */
  presenceTtlSeconds: 30,
  /** Scroll depth reports are throttled to this cadence. */
  scrollThrottleMs: 500
};
var MAX_EVENTS_PER_BATCH = 50;

export { MAX_EVENTS_PER_BATCH, TRACKING_CONFIG };
//# sourceMappingURL=chunk-MDSD4D7F.mjs.map
//# sourceMappingURL=chunk-MDSD4D7F.mjs.map